import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export function getHeader(token) {
  return {
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*", // Required for CORS support to work
    Authorization: token,
  };
}

// Generic API call function to reduce code duplication
export const fetchData = async (endpoint, token) => {
  try {
    const response = await axios.get(`${apiUrl}${endpoint}`, {
      headers: getHeader(token),
    });
    return response.data;
  } catch (err) {
    console.error(`Error fetching ${endpoint}:`, err);
    throw err;
  }
};
